import { render, staticRenderFns } from "./WorkCenterPlanning.vue?vue&type=template&id=263d0a5e&scoped=true&"
import script from "./WorkCenterPlanning.vue?vue&type=script&lang=js&"
export * from "./WorkCenterPlanning.vue?vue&type=script&lang=js&"
import style0 from "./WorkCenterPlanning.vue?vue&type=style&index=0&id=263d0a5e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263d0a5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListTile } from 'vuetify/lib/components/VList';
import { VListTileTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VCheckbox,VIcon,VList,VListTile,VListTileTitle,VMenu,VPagination})
